module.exports = __webpack_public_path__ + "static/media/ice2.c437df56.webp";